import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Server, Globe, Shield, HeadphonesIcon, Cpu, Cloud } from 'lucide-react';
const features = [{
  title: 'Web Hosting',
  description: 'Fast, secure, and reliable shared hosting for your personal or small business websites.',
  icon: Globe
}, {
  title: 'VPS Servers',
  description: 'Dedicated resources and full root access for applications that need more power.',
  icon: Server
}, {
  title: 'Dedicated Servers',
  description: 'Bare metal performance for enterprise applications and high-traffic websites.',
  icon: Cpu
}, {
  title: 'Domain Registration',
  description: 'Find and register the perfect domain name for your brand with free privacy protection.',
  icon: Cloud
}, {
  title: 'SSL Certificates',
  description: 'Secure your website and build customer trust with our premium SSL certificates.',
  icon: Shield
}, {
  title: '24/7 Support',
  description: 'Our expert team is always awake and ready to help you with any technical issues.',
  icon: HeadphonesIcon
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function Features() {
  return <section id="features" className="py-24 bg-slate-950 relative" data-id="element-1177">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1178">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1179">
          <h2 className="text-fox-500 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-1180">
            Our Services
          </h2>
          <h3 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-1181">
            Everything you need to succeed online
          </h3>
          <p className="text-slate-400 text-lg" data-id="element-1182">
            We provide a comprehensive suite of tools and services designed to
            make your online journey fast, reliable, and hassle-free.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-1183">
          {features.map((feature, index) => <motion.div key={index} variants={itemVariants} whileHover={{
          y: -5
        }} className="glass-panel p-8 rounded-2xl group hover:border-fox-500/50 transition-colors duration-300 relative overflow-hidden" data-id="element-1184">
              <div className="absolute top-0 right-0 w-32 h-32 bg-fox-500/5 rounded-full blur-2xl -mr-10 -mt-10 group-hover:bg-fox-500/10 transition-colors" data-id="element-1185" />

              <div className="w-14 h-14 bg-slate-800 rounded-xl flex items-center justify-center mb-6 group-hover:bg-fox-600/20 group-hover:text-fox-400 transition-colors border border-slate-700 group-hover:border-fox-500/30" data-id="element-1186">
                <feature.icon size={28} className="text-slate-300 group-hover:text-fox-400 transition-colors" data-id="element-1187" />
              </div>

              <h4 className="text-xl font-heading font-bold text-white mb-3" data-id="element-1188">
                {feature.title}
              </h4>
              <p className="text-slate-400 leading-relaxed" data-id="element-1189">
                {feature.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}